import { OmniElement, OmniStyleElement, html, css } from 'omni-ui';
import { produce } from 'immer';
import '../campaign-assist-field.js';

OmniStyleElement.register();

/**
 * Class for Attention Calculator Multi Rec Module Element
 * @extends OmniElement
 */
export class IdeaGeneratorInputs extends OmniElement {
  /**
   * @property {Object} context - Values passed in from wrapper/router
   * @property {Object} savedData - Data already saved in the API
   * @property {Object} schema - Values passed in from wrapper/router
   * @property {Object} ideaGeneratorInputs - Stored input values object
   */
  static get properties() {
    return {
      context: { type: Object },
      savedData: { type: Object },
      schema: { type: Object },
      ideaGeneratorInputs: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        omni-tile {
          margin-bottom: 2.413rem;
        }
        .title-wrapper {
          margin-left: 2.286rem;
        }
        omni-tile.module-wrapper::part(body-slot) {
          padding: 2.413rem 2.857rem 1.429rem 0;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.ideaGeneratorInputs = {};
  }

  firstUpdated() {
    if (Object.keys(this.savedData || {})?.length) {
      this.ideaGeneratorInputs = this.savedData?.generatedIdeas;
    }
  }

  /** method that handles passing the data up to the parent component to be saved. */
  #handleChildChange = e => {
    this.ideaGeneratorInputs = produce(this.ideaGeneratorInputs, draft => {
      draft[e.target.name] = e.target.value;
    });
    this.dispatchNewEvent('idea-generator-change', {
      detail: {
        generatedIdeas: this.ideaGeneratorInputs,
      },
    });
  };

  /**
   * @returns {html} Rendered HTML for the component
   */
  render() {
    return html` <omni-style
      @input="${this.#handleChildChange}"
      @change="${this.#handleChildChange}"
    >
      <omni-tile class="module-wrapper">
        <div class="title-wrapper">
          <h1 class="title mb-5 is-2">
            ${this.schema?.section_two_title ?? 'Idea Generator'}
          </h1>
          <div>
            <div class="columns">
              <div class="column">
                <div class="subtitle mb-2">Workshop</div>
                <div class="mb-5">
                  <campaign-assist-field
                    fieldId="workshop"
                    .fields=${this.context.assistFields}
                  >
                    <textarea
                      class="textarea"
                      name="input_one"
                      rows="5"
                      placeholder="Get to know your team with these creative and interactive icebreakers"
                      .value="${this.ideaGeneratorInputs?.input_one ?? ''}"
                    ></textarea>
                  </campaign-assist-field>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="subtitle mb-2">Randomizer</div>
                <campaign-assist-field
                  fieldId="randomizer"
                  .fields=${this.context.assistFields}
                >
                  <textarea
                    class="textarea"
                    name="input_two"
                    rows="5"
                    placeholder="Be inspired by a truly random concept and build a connection between this and the thoughtleader."
                    .value="${this.ideaGeneratorInputs?.input_two ?? ''}"
                  ></textarea>
                </campaign-assist-field>
              </div>
              <div class="column">
                <div class="subtitle mb-2">POV</div>
                <campaign-assist-field
                  fieldId="pov"
                  .fields=${this.context.assistFields}
                >
                  <textarea
                    class="textarea"
                    name="input_three"
                    rows="5"
                    placeholder="Consider the POV of someone and how they would come up with a campaign idea based on the winning thoughtleader"
                    .value="${this.ideaGeneratorInputs?.input_three ?? ''}"
                  ></textarea>
                </campaign-assist-field>
              </div>
              <div class="column">
                <div class="subtitle mb-2">Revolutionizer</div>
                <campaign-assist-field
                  fieldId="revolutionizer"
                  .fields=${this.context.assistFields}
                >
                  <textarea
                    class="textarea"
                    name="input_four"
                    rows="5"
                    placeholder="Write a list of how the category/company/brand goes about their day to day business - what things do they do"
                    .value="${this.ideaGeneratorInputs?.input_four ?? ''}"
                  ></textarea>
                </campaign-assist-field>
              </div>
            </div>
          </div>
        </div>
      </omni-tile>
    </omni-style>`;
  }
}

OmniElement.register('idea-generator-inputs', IdeaGeneratorInputs);
